export default __webpack_public_path__ + "static/media/cross.23f5928a.svg";